// libraries
import { removeFlowRules } from '@makemydeal/dr-shared-ui-utils/validationEngine/removeFlowRules';
import type { FieldNode, ValidationConfig } from '@makemydeal/dr-shared-ui-utils/validationEngine/types';
import { addressValidationConfig } from '@makemydeal/dr-shared-ui-utils/validationConfigs/addressValidationConfig';
import { customerValidationConfig } from '@makemydeal/dr-shared-ui-utils/validationConfigs/customerValidationConfig';

// Strip contract-flow gating so the shared regex/age rules fire in the default flow used by
// soft-pull. The stricter length checks (60 / 30 / 5) are added inline because soft-pull data
// ultimately reaches contracting — catching length violations here avoids fixing them twice.
const address = removeFlowRules(addressValidationConfig, 'contract');
const customer = removeFlowRules(customerValidationConfig, 'contract');

export const mandatoryDetailsValidationConfig: ValidationConfig = {
    streetAddress: {
        rules: [
            { type: 'REQUIRED', messages: 'Street Address is required.' },
            { type: 'MAX_LENGTH', params: { max: 60 }, messages: "Street Address can't be longer than 60 characters." },
            ...(address.streetAddress as FieldNode).rules
        ]
    },
    streetAddress2: {
        rules: [
            { type: 'MAX_LENGTH', params: { max: 60 }, messages: "Street Address 2 can't be longer than 60 characters." },
            ...(address.streetAddress2 as FieldNode).rules
        ]
    },
    city: {
        rules: [
            { type: 'REQUIRED', messages: 'City is required.' },
            { type: 'MAX_LENGTH', params: { max: 30 }, messages: "City can't be longer than 30 characters." },
            ...(address.city as FieldNode).rules
        ]
    },
    state: {
        rules: [{ type: 'REQUIRED', messages: 'State is required.' }]
    },
    postalCode: {
        rules: [
            { type: 'REQUIRED', messages: 'Postal Code is required.' },
            { type: 'MIN_LENGTH', params: { min: 5 }, messages: 'Postal code must be at least 5 characters.' },
            ...(address.zip as FieldNode).rules
        ]
    },
    dateOfBirth: {
        rules: [{ type: 'REQUIRED', messages: 'Date of Birth is required.' }, ...(customer.dateOfBirth as FieldNode).rules]
    }
};
